<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CircularProgressBar',
  props: {
    value: {
      type: Number,
      required: true,
    },
    strokeColor: {
      type: String,
      default: '#22ac8a',
    },
    bgColor: {
      type: String,
      default: '#ffffff',
    },
    speed: {
      type: Number,
      default: 300
    },
  },
  computed: {
    normalizedValue() {
      return Math.min(Math.max(this.value, 0), 100)
    },
    circleStyle() {
      return {
        '--progress-angle': `${this.normalizedValue * 3.6}deg`,
        '--progress-color': this.strokeColor,
        '--progress-bg-color': this.bgColor,
        width: "36px",
        height: "36px",
        transitionDuration: `${this.speed}ms`,
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  },
})
</script>

<template>
  <div class="circular-progress" :style="circleStyle">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.circular-progress {
  --progress-angle: 0deg;
  --progress-color: #22ac8a;
  --progress-bg-color: #ffffff;
  border-radius: 50%;
  background: conic-gradient(
    var(--progress-color) var(--progress-angle),
    var(--progress-bg-color) var(--progress-angle)
  );
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition-property: --progress-angle, --progress-color, --progress-bg-color;
  transition-timing-function: ease;
}

@property --progress-angle {
  syntax: '<angle>';
  inherits: false;
  initial-value: 0deg;
}

@property --progress-color {
  syntax: '<color>';
  inherits: false;
  initial-value: #22ac8a;
}

@property --progress-bg-color {
  syntax: '<color>';
  inherits: false;
  initial-value: #ffffff;
}

</style>